import { useEffect, useState } from "react";
import { Globe } from "lucide-react";
import { LANGUAGES, getLang, setLang, subscribeLang } from "@/lib/i18n";

export function LangRoot({ children }) {
  const [lang, setL] = useState(getLang());
  useEffect(() => { document.documentElement.lang = lang; return subscribeLang(setL); }, [lang]);
  return <div key={lang} className="contents">{children}</div>;
}

export default function LanguageSwitcher({ light = false, compact = false }) {
  return (
    <label className={`relative inline-flex items-center gap-1.5 h-10 ${compact ? "pl-2.5 pr-1.5" : "pl-3 pr-2"} rounded-full border text-sm cursor-pointer ${light ? "border-white/30 text-white hover:bg-white/10" : "border-slate-200 bg-white text-slate-700 hover:bg-slate-50"}`}>
      <Globe className="w-4 h-4 shrink-0" />
      <select
        value={getLang()}
        onChange={(e) => setLang(e.target.value)}
        className="bg-transparent outline-none cursor-pointer appearance-none pr-1 font-semibold uppercase text-xs"
        data-testid="language-switcher"
        aria-label="Language"
      >
        {LANGUAGES.map((l) => <option key={l.code} value={l.code} className="text-slate-900 normal-case">{compact ? l.code.toUpperCase() : `${l.code.toUpperCase()} · ${l.label}`}</option>)}
      </select>
    </label>
  );
}
